import { createPortal } from 'react-dom';
import { backdropStyle, grabberStyle, sheetStyle } from './SuperBottomSheet.styles';
import type { SuperBottomSheetProps } from './SuperBottomSheet.types';
import { useSuperBottomSheet } from './useSuperBottomSheet';

export function SuperBottomSheet(props: SuperBottomSheetProps) {
  const { open, title, ariaLabel, children } = props;
  const vm = useSuperBottomSheet(props);

  if (!open) return null;

  return createPortal(
    <div role="presentation" style={backdropStyle} onMouseDown={vm.handleBackdropClick}>
      {/* Escape key dismissal is wired up in useSuperBottomSheet. */}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        style={sheetStyle}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div aria-hidden style={grabberStyle} />
        {title && (
          <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: 22, color: 'var(--color-text)' }}>
            {title}
          </h2>
        )}
        <div style={{ overflowY: 'auto', flex: 1, minHeight: 0 }}>{children}</div>
      </div>
      <style>{`@keyframes gb-slide-up{from{transform:translateY(100%)}to{transform:translateY(0)}}`}</style>
    </div>,
    document.body,
  );
}
